import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export const CustomCalendarContainer: React.FC<{ children: React.ReactNode; inputRef: React.RefObject<HTMLInputElement> }> = ({
    children,
    inputRef
}) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const calendarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updatePosition = () => {
            if (inputRef.current) {
                const rect = inputRef.current.getBoundingClientRect();
                setPosition({
                    top: rect.bottom + window.scrollY,
                    left: rect.left + window.scrollX
                });
            }
        };

        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);

        return () => {
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [inputRef]);

    const calendarStyle: React.CSSProperties = {
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 10000,
    };

    return createPortal(
        <div ref={calendarRef} style={calendarStyle}>
            {children}
        </div>,
        document.body
    );
};